import React from 'react';
import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import { CommonTableProps } from '../../types/commons';
import {
  DndContext,
  closestCenter
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from './SortableItem';

/* styled */
const TableContent = styled.div`
  width: 100%;

  @media screen and (max-width: 1024px) {
    overflow: auto;
  }  
  @media screen and (max-width: 768px) {
    overflow: visible;
  }
`;
const TableWrap = styled(Table)`
  width: 100%;
  color: #333333;
  background-color: #ffffff;
  border-spacing: unset;
  border-bottom: 1px solid #dddddd;

thead {
  display: table-header-group;
  border-color: inherit;
  font-weight: bold;
  font-size: 0.875rem;
}
tbody {
  display: table-row-group;
  border-color: inherit;
  font-size: 0.875rem;
  color: #333333;

  tr:hover {
    background-color: rgba(255, 255, 255, 0.04);
  }
  tr:first-child td {
    border-top: unset;
  }
}
tr {
  position: relative;
  display: table-row;
  vertical-align: inherit;
  border-color: inherit;
  text-align: left;
  background: #ffffff;
}
td {
  padding: 1rem 0.5rem;
  border-top: 1px solid #dddddd;
  font-weight: 400;
  word-break: break-all;
  text-align: center;

  &.no-list-data {
    text-align: center;
  }
  
  &.action-button {
    div {
      display: inline;
      border-radius: 1rem;
      cursor: pointer;

      :hover {
        color: #732ec5;
      }
    }
  }
  &.action-button.list {
    div {
      padding: 0.375rem 0.6875rem;

      :hover {
        color: #e6e5e8;
      }
    }
  }

  &.more-button {
    display: flex;
    justify-content: center;

    button {
      padding: 0.5rem;
      width: 100%;
      min-width: 4.25rem;
      font-size: 12px;
      color: #ffffff;
      border: 0px;
      background-color: #481684;
      cursor: pointer;
      box-shadow: 0 0 1px 0 rgb(0 0 0 / 20%), 0 2px 4px -2px rgb(0 0 0 / 30%);
    
      :hover {
        background: #732ec5;
      }
    }
  }
  
  &.more-button2 {
    background: #fff0c9;
    cursor: move;
  }
  .no-list-data {
    text-align: center;
  } 
}
`;
const TableTR = styled.tr`
th {
  padding: 0.25rem .5rem;
  background: #3a4254;
  border-bottom: 1px solid #3a4254;
  top: 60px;
  word-break: keep-all;
  cursor: default;
  color: #ffffff;
  font-weight: 600;
  text-align: center;

  :first-child {
    border-top-left-radius: .35rem;
    padding: 1.125rem .5rem;
  }
  :last-child {
    border-top-right-radius: .35rem;
    padding: .75rem 1rem;
  }
  
  .c-blue { color: #732ec5 !important; }
  .d-none { display: none; }
  span {
    svg {
      color: #ffffff;
    }
    :hover {
      svg {
        display: initial;
      }
    }
  }
}
`;

const CommonTable = ({
  columns,
  datas,
  headItems,
  handleDrag,
}:CommonTableProps) => {
  
  return (
    <TableContent className='table-wrap'>
      <DndContext
        collisionDetection={closestCenter}
        onDragOver={(e) => handleDrag(e, 'over')}
        onDragEnd={(e) => handleDrag(e, 'end')}
      >
        <TableWrap>
          <thead>
            <TableTR>
              <th rowSpan={2} style={{width: '0%'}}></th>
              <th rowSpan={2} style={{width: '15%'}}>코드명</th>
              <th rowSpan={2} style={{width: '10%'}}>코드</th>
              <th rowSpan={2} style={{width: '5%'}}>순서</th>
              <th rowSpan={2} style={{width: '10%'}}>사용여부</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item1</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item2</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item3</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item4</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item5</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item6</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item7</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item8</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item9</th>
              <th style={{width: '5%', padding: '0.875rem 0.5rem 0.375rem 0.5rem'}}>Item10</th>
              <th rowSpan={2} style={{width: '8%'}}></th>
            </TableTR>
            <TableTR>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item1}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item2}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item3}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item4}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item5}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item6}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item7}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item8}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item9}</th>
              <th style={{padding: '0.375rem 0.5rem 0.875rem 0.5rem'}}>{headItems.item10}</th>
            </TableTR>
          </thead>
          <tbody>
            <SortableContext
              items={datas.map((item:any) => item.detail)}
              strategy={verticalListSortingStrategy}
            >
            {datas.length > 0 ? datas.map((item:any, index:number) => (
              <SortableItem key={index} item={item} columns={columns} idx={index} id={item.detail} />
            )) : (
              <tr>
                <td className='no-list-data' colSpan={columns.length}>
                  {'No data'}
                </td>
              </tr>
            )}
          </SortableContext>
          </tbody>
        </TableWrap>
      </DndContext>
    </TableContent>
  );
};

export default CommonTable;